import { CommonModule } from '@angular/common';
import { Component, computed, Input, OnInit, signal } from '@angular/core';
import { CompanyIdentityComponent } from 'src/app/dashboard/dashboard-components/company-identity/company-identity.component';
import { CompanyBalanceComponent } from 'src/app/dashboard/dashboard-components/company-identity/components/company-balance/company-balance.component';
import { OverviewComponent } from 'src/app/dashboard/dashboard-components/company-identity/components/overview/overview.component';
import { DashboardOverviewComponent } from 'src/app/dashboard/dashboard-components/dashboard-overview/dashboard-overview.component';
import { PromoFeaturesComponent } from 'src/app/report/components/promo-features/promo-features.component';
import { fadeInUpAnimation } from 'src/app/shared/animations/animations';
import { PricePlansComponent } from 'src/app/shared/price-plans/price-plans.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-section-benchmark',
  standalone: true,
  imports: [
    CommonModule,
    DashboardOverviewComponent,
    CompanyBalanceComponent,
    OverviewComponent,
    PromoFeaturesComponent,
    PricePlansComponent,
    SharedModule
  ],
  animations: [fadeInUpAnimation],
  templateUrl: './section-benchmark.component.html',
  styleUrls: ['./section-benchmark.component.scss']
})
export class SectionBenchmarkComponent implements OnInit {
 
  @Input() company: any;
  @Input() companyEureso: any;
  @Input() companyAteco: any;
  @Input() istat: any;

  companyPiva$ = computed(() => this.company$().alternateSummary?.vatRegistrationNumber)
  companyAteco$ = computed(() => this.company$().alternateSummary?.atecoCode)
  company$ = signal<any>(null);
  titleIntro: string = 'inactive';


  visibilityState: { [key: string]: string } = {
    titleIntro: 'inactive',
    innovateIntro: 'inactive'
  };
  
  ngOnInit(): void {
    this.company$.set(this.company);
  }
  onVisibilityChanged(element: string, visible: boolean) {
    if(Object.keys(this.visibilityState).includes(element) && visible) {
      this.visibilityState[element] = visible ? '*' : 'inactive';
    }
  }
  
}
